import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import { AdminLayout } from './components/AdminLayout';
import { AdminLogin } from './pages/AdminLogin';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { AdminsPage } from './pages/AdminsPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { AnnouncementsPage } from './pages/AnnouncementsPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { SectionsPage } from './pages/SectionsPage';
import { ReferralsPage } from './pages/ReferralsPage';
import { SettingsPage } from './pages/SettingsPage';
import { InterviewsPage } from './pages/InterviewsPage';
import { FeedbackPage } from './pages/FeedbackPage';
import { EmailPage } from './pages/EmailPage';
import { FullPageRocketLoader } from './components/RocketLoader';

const PrivateRoute = ({ children, superOnly = false }) => {
  const { admin, loading } = useAdminAuth();
  if (loading) return <FullPageRocketLoader message="Loading…" />;
  if (!admin) return <Navigate to="/login" replace />;
  if (superOnly && admin.role !== 'superadmin') return <Navigate to="/dashboard" replace />;
  return <AdminLayout>{children}</AdminLayout>;
};

const PublicRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();
  if (loading) return <FullPageRocketLoader />;
  return admin ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><AdminLogin /></PublicRoute>} />
          <Route path="/dashboard"     element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/users"         element={<PrivateRoute><UsersPage /></PrivateRoute>} />
          <Route path="/admins"        element={<PrivateRoute superOnly><AdminsPage /></PrivateRoute>} />
          <Route path="/templates"     element={<PrivateRoute><TemplatesPage /></PrivateRoute>} />
          <Route path="/documents"     element={<PrivateRoute><DocumentsPage /></PrivateRoute>} />
          <Route path="/announcements" element={<PrivateRoute><AnnouncementsPage /></PrivateRoute>} />
          <Route path="/about"         element={<PrivateRoute><AboutPage /></PrivateRoute>} />
          <Route path="/blog"          element={<PrivateRoute><BlogPage /></PrivateRoute>} />
          <Route path="/sections"      element={<PrivateRoute><SectionsPage /></PrivateRoute>} />
          <Route path="/referrals"     element={<PrivateRoute><ReferralsPage /></PrivateRoute>} />
          <Route path="/interviews"    element={<PrivateRoute><InterviewsPage /></PrivateRoute>} />
          <Route path="/feedback"      element={<PrivateRoute><FeedbackPage /></PrivateRoute>} />
          <Route path="/email"         element={<PrivateRoute><EmailPage /></PrivateRoute>} />
          <Route path="/settings"      element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="*"              element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
